<template>
  <v-card outlined class="ma-2" elevation="2">
    <v-card-title class="text-h5 title-header"
      >{{ $t("llm_config.index_parameters.title") }}
    </v-card-title>
    <v-card-text>
      <v-row justify="center" align="center">
        <v-col cols="12" md="12">
          <v-card dense outlined height="100%">
            <v-card-title>
              {{
                $t(
                  "llm_config.index_parameters.service_client.is_use_rag_title"
                )
              }}
            </v-card-title>
            <v-card-text>
              <v-row no-gutters justify="center" align="center">
                <v-col cols="12">
                  <v-row justify="center" align="center">
                    <v-col cols="auto">
                      <span
                        class="red--text title-3"
                        v-html="
                          `${$t(
                            'llm_config.index_parameters.service_client.is_use_rag_warning'
                          )}`
                        "
                      >
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-divider class="mx-12"></v-divider>
                <v-col cols="12">
                  <v-row justify="center" align="center">
                    <v-col cols="auto">
                      <v-checkbox
                        v-model="is_use_context"
                        :label="
                          $t(
                            'llm_config.index_parameters.service_client.is_use_rag'
                          )
                        "
                        :rules="form_roles.booleanField"
                        outlined
                        required
                        hide-details
                        class="ma-0"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <template v-if="is_use_context">
          <v-col cols="12" md="12">
            <v-card
              outlined
              height="100%"
              :loading="showing_collections.service_client_loading"
              :disabled="showing_collections.service_client_loading"
            >
              <v-card-title>
                {{ $t("llm_config.index_parameters.service_client.title") }}
              </v-card-title>
              <v-card-text>
                <v-row justify="start" align="center">
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="service_client_db_name"
                      prepend-inner-icon="mdi-database"
                      :items="database_list"
                      :label="
                        $t(
                          'llm_config.index_parameters.service_client.database_name_label'
                        )
                      "
                      :rules="form_roles.text"
                      outlined
                      required
                      light
                      :menu-props="{ bottom: true, offsetY: true }"
                      @change="rerender_collections('service_client')"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <collections-fetch
                      ref="service_client_collections_fetch"
                      v-if="showing_collections.service_client"
                      :value="client_service_collection_name"
                      :database_name="service_client_db_name"
                      :form_roles="form_roles"
                      :label="
                        $t(
                          'llm_config.index_parameters.service_client.collection_name_label'
                        )
                      "
                      :placeholder="
                        $t(
                          'llm_config.index_parameters.service_client.collection_name_placeholder'
                        )
                      "
                      @showing_collections_text="
                        showing_collections.service_client = false
                      "
                      @input="client_service_collection_name = $event"
                      @loading="
                        showing_collections.service_client_loading = $event
                      "
                    />
                    <v-text-field
                      v-else
                      v-model="client_service_collection_name"
                      :label="
                        $t(
                          'llm_config.index_parameters.service_client.collection_name_label'
                        )
                      "
                      :placeholder="
                        $t(
                          'llm_config.index_parameters.service_client.collection_name_placeholder'
                        )
                      "
                      :rules="form_roles.text"
                      outlined
                      required
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-card outlined class="pa-4">
                      <v-slider
                        v-model="client_services_llm_match_threshold"
                        thumb-label="always"
                        :max="20"
                        :min="0"
                        :step="1"
                        :label="
                          $t(
                            'llm_config.index_parameters.service_client.level_of_detail'
                          )
                        "
                        :hint="
                          $t(
                            'llm_config.index_parameters.service_client.level_of_detail_hint'
                          )
                        "
                        persistent-hint
                        color="#1141ce"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="client_services_llm_match_threshold"
                            class="mt-0 pt-0"
                            type="number"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <v-card
              outlined
              height="100%"
              :loading="showing_collections.products_reco_loading"
              :disabled="showing_collections.products_reco_loading"
            >
              <v-card-title>
                {{ $t("llm_config.index_parameters.reco_products.title") }}
              </v-card-title>
              <v-card-text>
                <v-row justify="start" align="center">
                  <v-col cols="12">
                    <v-row justify="center" align="center">
                      <v-col cols="auto">
                        <span class="red--text title-3">
                          ⚠️{{
                            $t(
                              "llm_config.index_parameters.reco_products.product_rag_for_recommandation"
                            )
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters justify="center" align="center">
                      <v-col cols="auto">
                        <v-select
                          v-model="is_product"
                          :items="[
                            {
                              text: $t(
                                'llm_config.index_parameters.reco_products.use_yes'
                              ),
                              value: true,
                            },
                            {
                              text: $t(
                                'llm_config.index_parameters.reco_products.use_no'
                              ),
                              value: false,
                            },
                          ]"
                          :label="
                            $t(
                              'llm_config.index_parameters.reco_products.is_use_product_recommandation'
                            )
                          "
                          :rules="form_roles.booleanField"
                          outlined
                          required
                          persistent-hint
                          :menu-props="{ bottom: true, offsetY: true }"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <template v-if="is_product">
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="product_db_name"
                        :items="database_list"
                        prepend-inner-icon="mdi-database"
                        :label="
                          $t(
                            'llm_config.index_parameters.reco_products.database_name_label'
                          )
                        "
                        :rules="form_roles.text"
                        outlined
                        required
                        @change="rerender_collections('products_reco')"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <collections-fetch
                        ref="products_reco_collections_fetch"
                        v-if="showing_collections.products_reco"
                        :value="product_collection_name"
                        :database_name="product_db_name"
                        :form_roles="form_roles"
                        :label="
                          $t(
                            'llm_config.index_parameters.reco_products.collection_name_label'
                          )
                        "
                        :placeholder="
                          $t(
                            'llm_config.index_parameters.reco_products.collection_name_placeholder'
                          )
                        "
                        @showing_collections_text="
                          showing_collections.products_reco = false
                        "
                        @input="product_collection_name = $event"
                        @loading="
                          showing_collections.products_reco_loading = $event
                        "
                      />
                      <v-text-field
                        v-else
                        v-model="product_collection_name"
                        :label="
                          $t(
                            'llm_config.index_parameters.reco_products.collection_name_label'
                          )
                        "
                        :placeholder="
                          $t(
                            'llm_config.index_parameters.reco_products.collection_name_placeholder'
                          )
                        "
                        :rules="form_roles.text"
                        outlined
                        required
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-card outlined class="pa-4">
                        <v-slider
                          v-model="product_llm_match_threshold"
                          thumb-label="always"
                          :max="20"
                          :min="0"
                          :step="1"
                          :label="
                            $t(
                              'llm_config.index_parameters.reco_products.product_llm_match_threshold_label'
                            )
                          "
                          :hint="
                            $t(
                              'llm_config.index_parameters.reco_products.product_llm_match_threshold'
                            )
                          "
                          persistent-hint
                          color="#1141ce"
                        >
                          <template v-slot:append>
                            <v-text-field
                              v-model="product_llm_match_threshold"
                              class="mt-0 pt-0"
                              type="number"
                              style="width: 60px"
                              :rules="form_roles.number"
                            ></v-text-field>
                          </template>
                        </v-slider>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-card outlined class="pa-4">
                        <v-slider
                          v-model="product_carousel_match_threshold"
                          thumb-label="always"
                          :max="20"
                          :min="0"
                          :step="1"
                          :label="
                            $t(
                              'llm_config.index_parameters.reco_products.product_carousel_match_threshold_label'
                            )
                          "
                          :hint="
                            $t(
                              'llm_config.index_parameters.reco_products.product_carousel_match_threshold'
                            )
                          "
                          persistent-hint
                          color="#1141ce"
                        >
                          <template v-slot:append>
                            <v-text-field
                              v-model="product_carousel_match_threshold"
                              class="mt-0 pt-0"
                              type="number"
                              style="width: 60px"
                              :rules="form_roles.number"
                            ></v-text-field>
                          </template>
                        </v-slider>
                      </v-card>
                    </v-col>
                  </template>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import CollectionsFetch from "./CollectionsFetch.vue";
export default {
  name: "IndexParameters",
  components: {
    "collections-fetch": CollectionsFetch,
  },
  data() {
    return {
      index_folder_paths: [
        "llm_package/db_index_local/chroma",
        "llm_package/db_index_local/faiss",
      ],
      database_list: ["test", "production"],
      llmCollections: [],
      showing_collections: {
        service_client: true,
        products_reco: true,
        service_client_loading: false,
        products_reco_loading: false,
      },
    };
  },
  props: {
    openaiConfig: {
      type: Object,
      required: true,
    },
    form_roles: {
      type: Object,
      required: true,
    },
  },
  async created() {
    try {
      if (!this.openaiConfig?.langchain_settings?.index_param) {
        this.$set(this.openaiConfig.langchain_settings, "index_param", {
          service_client_db_name: "test",
          client_service_collection_name: null,
          product_db_name: "test",
          product_collection_name: null,
        });
      }
      // Ensure default reactive keys exist to avoid Vue 2 reactivity caveats
      const defaults1 = {
        service_client_db_name: "test",
        client_service_collection_name: null,
        product_db_name: "test",
        product_collection_name: null,
      };
      Object.keys(defaults1).forEach((key) => {
        if (!(key in this.openaiConfig.langchain_settings.index_param)) {
          this.$set(
            this.openaiConfig.langchain_settings.index_param,
            key,
            defaults1[key]
          );
        }
      });

      const defaults2 = {
        is_product: false,
        is_use_context: false,
        client_services_llm_match_threshold: 19,
        product_llm_match_threshold: 19,
        product_carousel_match_threshold: 20,
      };
      Object.keys(defaults2).forEach((key) => {
        if (!(key in this.openaiConfig.langchain_settings)) {
          this.$set(this.openaiConfig.langchain_settings, key, defaults2[key]);
        }
      });
    } catch (e) {
      console.log(e);
      this.$store.dispatch("setSnackbar", {
        showing: true,
        text: `There is an error ${e.message}`,
        color: "error",
      });
      this.loading = false;
    }

    if (this.openaiConfig?.langchain_settings?.index_param) {
      if (
        !this.openaiConfig?.langchain_settings?.index_param
          ?.service_client_db_name
      ) {
        this.$set(
          this.openaiConfig.langchain_settings.index_param,
          "service_client_db_name",
          "test"
        );
      }
      if (
        !this.openaiConfig?.langchain_settings?.index_param?.product_db_name
      ) {
        this.$set(
          this.openaiConfig.langchain_settings.index_param,
          "product_db_name",
          "test"
        );
      }
    }
  },
  computed: {
    service_client_db_name: {
      get() {
        return (
          this.openaiConfig.langchain_settings.index_param
            .service_client_db_name || null
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.index_param,
          "service_client_db_name",
          value
        );
      },
    },
    client_service_collection_name: {
      get() {
        return (
          this.openaiConfig.langchain_settings.index_param
            .client_service_collection_name || null
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.index_param,
          "client_service_collection_name",
          value
        );
      },
    },
    product_db_name: {
      get() {
        return (
          this.openaiConfig.langchain_settings.index_param.product_db_name ||
          null
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.index_param,
          "product_db_name",
          value
        );
      },
    },
    product_collection_name: {
      get() {
        return (
          this.openaiConfig.langchain_settings.index_param
            .product_collection_name || null
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.index_param,
          "product_collection_name",
          value
        );
      },
    },
    product_llm_match_threshold: {
      get() {
        return (
          this.openaiConfig.langchain_settings.index_param
            .product_llm_match_threshold || 19
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.index_param,
          "product_llm_match_threshold",
          value
        );
      },
    },
    product_carousel_match_threshold: {
      get() {
        return (
          this.openaiConfig.langchain_settings.index_param
            .product_carousel_match_threshold || 20
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.index_param,
          "product_carousel_match_threshold",
          value
        );
      },
    },
    is_product: {
      get() {
        return this.openaiConfig.langchain_settings.is_product || false;
      },
      set(value) {
        this.$set(this.openaiConfig.langchain_settings, "is_product", value);
      },
    },
    is_use_context: {
      get() {
        return this.openaiConfig.langchain_settings.is_use_context || false;
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings,
          "is_use_context",
          value
        );
      },
    },
    client_services_llm_match_threshold: {
      get() {
        return (
          this.openaiConfig.langchain_settings
            .client_services_llm_match_threshold || 19
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings,
          "client_services_llm_match_threshold",
          value
        );
      },
    },
  },
  methods: {
    // No extra handlers needed for v-model
    emitLoading(loading) {
      this.$emit("loading", loading);
    },
    rerender_collections(type) {
      // Force re-render of collections component by toggling visibility
      this.showing_collections[type] = false;
      this.$nextTick(() => {
        this.showing_collections[type] = true;
      });
    },
  },
};
</script>

<style scoped>
.title-header {
  font-weight: bold;
  color: #1141ce; /* Vuetify primary color */
}
</style>
